import script from "./UpdateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateCard.vue?vue&type=script&setup=true&lang=js"

import "./UpdateCard.vue?vue&type=style&index=0&id=16a8a0a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a8a0a5"]])

export default __exports__